import { GridRequest } from "projects/app-core/src/models/gridRequest";

export interface PartnerCampaignGridRequest
  extends GridRequest<
    PartnerCampaignSort,
    PartnerCampaignFilter,
    PartnerCampaignSearch,
    PartnerCampaignDateFilter
  > {}

export enum PartnerCampaignSort {
  CREATED_AT = "CREATED_AT",
  CAMPAIGN_DATE = "CAMPAIGN_DATE",
}

export enum PartnerCampaignSearch {
  NAME = "NAME",
}

export enum PartnerCampaignDateFilter {
  CAMPAIGN_ON = "CAMPAIGN_ON",
}

export enum PartnerCampaignFilter {
  PARTNER_ID = "PARTNER_ID",
  PRESENTER_ID = "PRESENTER_ID",
  TEST_CAMPAIGN = "TEST_CAMPAIGN",
}
